import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { collectCapabilities } from '#pplx/frontend/composer-sdk/plugins/internal/capabilities/utils.js';
export function createPlugin(config) {
    if (!config.id) {
        throw new Error('createPlugin: `id` is required and must be non-empty.');
    }
    // Flatten and validate the tagged capabilities into the flat shape consumers read.
    const { components, providers, plusMenuItems, plusMenuOpenChange, primaryActions, filePicker, fileDrop, filePaste, keyboard, link, mentions, } = collectCapabilities(config.id, config.capabilities);
    // Snapshot only the `kind` off each capability for the public `Plugin.capabilities`
    // field. Matches the declared `readonly Pick<Capability, 'kind'>[]` type: capability
    // hosts have already read whatever config they need, so consumers only need to know
    // which kinds this plugin contributes for downstream resolution (e.g. node registration).
    const capabilities = Object.freeze(config.capabilities.map(({ kind }) => Object.freeze({ kind })));
    // A plugin object is shared across surfaces and every render, so freeze it: a stray mutation
    // can't then quietly change it for everyone else. The `readonly` types document this, but only
    // freeze enforces it at runtime. `components` is always a frozen array (never `undefined`), so
    // consumers can iterate it unconditionally — including ones that call `plugin.components.some(...)`.
    return Object.freeze({
        id: config.id,
        capabilities,
        hasContent: config.hasContent,
        components: components.length > 0
            ? Object.freeze(components)
            : EMPTY_ARRAY,
        typeahead: providers.length > 0 ? Object.freeze(providers) : undefined,
        plusMenu: plusMenuItems.length > 0
            ? Object.freeze(plusMenuItems)
            : undefined,
        plusMenuOpenChange: plusMenuOpenChange.length > 0 ? Object.freeze(plusMenuOpenChange) : undefined,
        primaryAction: primaryActions.length > 0
            ? Object.freeze(primaryActions)
            : undefined,
        filePicker,
        fileDrop,
        filePaste,
        keyboard,
        link,
        mentions: mentions.length > 0
            ? Object.freeze(mentions)
            : undefined,
    });
}
//# sourceMappingURL=createPlugin.js.map